import React, { CSSProperties, ReactNode } from 'react';
import styles from '../layout.module.scss';

type MediumWidthContainerProps = {
    extraClassNames?: string;
    extraStyles?: CSSProperties;
    children: ReactNode;
    childrenClassNames?: string;
    header?: string;
};

const MediumWidthContainer = ({
    extraClassNames = '',
    extraStyles,
    children,
    childrenClassNames,
    header,
}: MediumWidthContainerProps) => (
    <div className={`${styles.container1500} ${extraClassNames}`} style={extraStyles}>
        {header ? <h2 className={styles.h2}>{header}</h2> : null}
        {childrenClassNames ? <div className={childrenClassNames}>{children}</div> : children}
    </div>
);

export default MediumWidthContainer;
